import React, { createContext, useState } from "react";

const PrintContext = createContext();

export const CHECKS = {
  PATIENT_DETAILS_ERR: 512,
  ASSESSMENTS_ERR: 513,
};

const PrintProvider = ({ children }) => {
  const [currentChecks, setCurrentChecks] = useState(() =>
    Object.values(CHECKS).reduce(
      (acc, check) => ({ ...acc, [check]: false }),
      {}
    )
  );

  const completed = React.useMemo(
    () => Object.values(currentChecks).every((check) => check === true),
    [currentChecks]
  );

  const errored = React.useMemo(() => {
    return Object.values(currentChecks).some(
      (check) => typeof check === "string"
    );
  }, [currentChecks]);

  const markAsDone = React.useCallback((check) => {
    setCurrentChecks((prev) => ({
      ...prev,
      [check]: true,
    }));
  }, []);

  const markAsError = React.useCallback((check, errorCode) => {
    setCurrentChecks((prev) => ({
      ...prev,
      [check]: errorCode?.toString(),
    }));
  }, []);

  const getErrorCode = React.useCallback(() => {
    if (!errored) return null;
    const errorCodes = Object.values(currentChecks).filter(
      (check) => typeof check === "string"
    );
    return errorCodes[0];
  }, [errored, currentChecks]);

  const getErrorCheck = React.useCallback(() => {
    if (!errored) return null;
    const errorChecks = Object.keys(currentChecks).filter(
      (check) => typeof currentChecks[check] === "string"
    );
    return errorChecks[0];
  }, [errored, currentChecks]);

  const value = React.useMemo(
    () => ({
      completed,
      markAsDone,
      markAsError,
    }),
    [completed]
  );

  return (
    <PrintContext.Provider value={value}>
      {(completed || errored) && (
        <div
          id="completed"
          style={{ display: "none" }} // comment this to view check
          data-code={completed ? 1 : 0}
          data-reason={getErrorCheck()}
          data-error-code={getErrorCode()}
        >
          {JSON.stringify({ completed, errored, currentChecks })}
        </div>
      )}
      {children}
    </PrintContext.Provider>
  );
};

export { PrintContext, PrintProvider };
